import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import Fade from "react-reveal/Fade";
import proCover from "../images/pro_cover.svg"
import aboutCover from "../images/about.svg";
import Accordion from "./elements/accordion";
import Footer from "./Footer";
import ReactTooltip from "react-tooltip";
import { getConektaPlanes, getCuponByCodigo, loggedIn, postConektaSuscription, postSuscripcionData, getConektaCustomer } from "./API Functions";
import { Helmet } from "react-helmet";
import NumberFormat from 'react-number-format';
import successUrl from "../images/successUrl.svg";
import failUrl from "../images/failUrl.svg";

function ProCheckout(props) {
    const [isToggled, setToggled] = useState(false);
    const toggleTrueFalse = () => setToggled(!isToggled);
    const [card, setCard] = useState("");
    const [current_card, setCurrentCard] = useState("");
    const [plan_price, setPlanPrice] = useState(0);
    const [plan_id, setPlanId] = useState("");
    const [loading, setLoading] = useState(false);

    const [accepted_terms, setAcceptedTerms] = useState(false);

    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [name, setName] = useState("");
    const [cvc, setCvc] = useState("");
    const [cupon, setCupon] = useState([]);

    const [cardError, setCardError] = useState("");
    const [monthError, setMonthError] = useState("");
    const [yearError, setYearError] = useState("");
    const [nameError, setNameError] = useState("");
    const [cvcError, setCvcError] = useState("");
    const [formError, setFormError] = useState("");
    const [cuponError, setCuponError] = useState("");
    const [termsError, setTermsError] = useState("");
    var [timeout, setTimeoutCode] = useState(0);

    useEffect(() => {
        console.log(props);
        if (props.location.state) {
            const plan = props.location.state.plan_id;
            if (plan == 2) {
                setToggled(true);
            }
            setPlanPrice(props.location.state.plan_price);
            setPlanId(plan);
        } else {
            window.location.replace('/login');
        }
        getConektaCustomer().then(res => {
            console.log(res);
        })
    }, [])

    function validateFields() {
        let cardError = ""
        let mmError = ""
        let nameError = ""
        let cvcError = ""
        let formError = ""
        let aaError = ""
        let termsError = ""
        // CARD NUMBER
        if (card == "") {
            cardError = "Requerido"
        } else {
            const card_validate = window.Conekta.card.validateNumber(card);

            if (!card_validate) {
                formError = "El numero de tarjeta es invalido"
            }
        }

        //CVC
        if (cvc == "") {
            cvcError = "Requerido"
        } else {
            const cvc_validate = window.Conekta.card.validateCVC(cvc);

            if (!cvc_validate) {
                formError = "CVC invalido"
            }
        }

        //MONTH AND YEAR
        if (month == "") {
            mmError = "Requerido"
        } else {
            const date_validate = window.Conekta.card.validateExpirationDate(month, year);

            if (!date_validate) {
                formError = "El numero de tarjeta es invalido"
            }
        }

        if (year == "") {
            aaError = "Requerido"
        } else {
            const date_validate = window.Conekta.card.validateExpirationDate(month, year);

            if (!date_validate) {
                formError = "El numero de tarjeta es invalido"
            }
        }

        if (name == "") {
            nameError = "Requerido"
        }

        if (accepted_terms == false) {
            termsError = "Debes de aceptar los términos y condiciones."
        }

        if (cardError || nameError || cvcError || mmError || aaError || formError || termsError) {
            setCardError(cardError);
            setNameError(nameError);
            setCvcError(cvcError);
            setMonthError(mmError);
            setYearError(aaError);
            setFormError(formError);
            setTermsError(termsError);
            return false
        } else {
            setCardError(cardError);
            setNameError(nameError);
            setCvcError(cvcError);
            setMonthError(mmError);
            setYearError(aaError);
            setFormError(formError);
            setTermsError(termsError);
            return true
        }
    }

    function handleCardChange(e) {
        const value = e.target.value;
        const card = window.Conekta.card.getBrand(value);
        setCard(value);
        setCurrentCard(card);
        console.log(current_card)
    }

    function ConektaPayment() {
        window.Conekta.setPublicKey('key_dBw4SNwzUS2f1H3RV9xnraQ');
        setLoading(true);
        var tokenParams = {
            "card": {
                "number": card,
                "name": name,
                "exp_year": year,
                "exp_month": month,
                "cvc": cvc
            }
        };
        var data = {
            plan_id: plan_id,
        }

        var conektaSuccessResponseHandler = function (token) {
            data = {
                ...data,
                card_token: token.id,
                cupon_id : cupon.id ? cupon.id : 0
            }
            console.log(data)
            postConektaSuscription(data).then(res => {
                if (res) {
                    console.log(res,'data')
                    if(res.pro){
                        localStorage.setItem('negocio', JSON.stringify(res.negocio));
                        window.location.replace("/pro/gracias")
                    }else{
                        data = {
                            id: res.suscripcion.id,
                            customer_data: res.customer.id
                        }
                        postSuscripcionData(data).then(res => {
                            if (res) {
                                localStorage.setItem('negocio', JSON.stringify(res.negocio));
                                window.location.replace("/pro/gracias")
                            }
                        })
                    }
                } else {
                    setCardError(res.data.message);
                    setTimeout(setCardError(""), 3000);
                }
            })
        };
        var conektaErrorResponseHandler = function (response) {
            console.log('Error')
            setCardError(response.message_to_purchaser);
            setTimeout(setCardError(""), 3000);

        };
        const isValid = validateFields()
        if (isValid) {
            var order = window.Conekta.Token.create(tokenParams, conektaSuccessResponseHandler, conektaErrorResponseHandler);
            console.log(order);
        }
        setTimeout(() => {
            setLoading(false);
        }, 1000);

    }

    function searchCupon(e) {
        var cupon_code = e; // this is the search text
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
            getCuponByCodigo(cupon_code).then(res => {
                if (res) {
                    setCupon(res)
                } else {
                    setCuponError("Codigo invalido.")
                    setTimeout(() => {
                        setCuponError("")
                    }, 1500);
                }
            })
        }, 1500);
    }

    function changePlan(status) {
        toggleTrueFalse();
        if (!status) {
            setPlanId(2);
            setPlanPrice(2500);
        } else {
            setPlanId(1);
            setPlanPrice(250);
        }
    }

    return (
        <>
            {plan_price > 0 ?
                <div className="pro-container__checkout">
                    <Helmet
                        script={[{ src: "https://cdn.conekta.io/js/latest/conekta.js" }]}
                    >

                    </Helmet>
                    <Link to="/" className="okkiLogo">
                        <div>
                            <svg width="82" height="82" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M45.5925 39.8231C46.9383 39.8904 48.0654 38.8137 48.0654 37.468V35.1633C48.0654 34.8773 48.4019 34.7259 48.6206 34.9109L53.9869 39.3016C54.4243 39.6549 54.9458 39.8399 55.4841 39.8399C56.1738 39.8399 56.8467 39.5371 57.3009 38.982C58.1252 37.9726 57.9738 36.4923 56.9645 35.668L52.4224 31.9502C52.086 31.681 52.086 31.1764 52.4224 30.9072L56.9645 27.1894C57.9738 26.3651 58.1252 24.8848 57.3009 23.8754C56.4766 22.8661 54.9963 22.7147 53.9869 23.539L48.6206 27.9296C48.4019 28.1147 48.0654 27.9465 48.0654 27.6773V25.4231C48.0654 24.1614 47.0897 23.068 45.828 23.0007C44.4822 22.9334 43.3551 24.01 43.3551 25.3558V37.4007C43.3551 38.6623 44.3308 39.7558 45.5925 39.8231ZM36.4075 42.1782C35.0617 42.1109 33.9346 43.1876 33.9346 44.5334V46.838C33.9346 47.124 33.5981 47.2754 33.3794 47.0904L28.0131 42.6997C27.5757 42.3465 27.0542 42.1614 26.5159 42.1614C25.8262 42.1614 25.1533 42.4642 24.6991 43.0194C23.8748 44.0287 24.0262 45.5091 25.0355 46.3334L29.5776 50.0511C29.914 50.3203 29.914 50.825 29.5776 51.0941L25.0355 54.8119C24.0262 55.6362 23.8748 57.1165 24.6991 58.1259C25.5234 59.1352 27.0037 59.2866 28.0131 58.4623L33.3794 54.0717C33.5981 53.8866 33.9346 54.0549 33.9346 54.324V56.5614C33.9346 57.8231 34.9103 58.9165 36.172 58.9838C37.5178 59.0511 38.6449 57.9745 38.6449 56.6287V44.5838C38.6449 43.339 37.6692 42.2455 36.4075 42.1782ZM31.4112 23.0007C26.7682 23.0007 23 26.7689 23 31.4119C23 36.0549 26.7682 39.8231 31.4112 39.8231C36.0542 39.8231 39.8224 36.0549 39.8224 31.4119C39.8224 26.7689 36.0542 23.0007 31.4112 23.0007ZM31.4112 35.1128C29.3757 35.1128 27.7103 33.4474 27.7103 31.4119C27.7103 29.3764 29.3757 27.7109 31.4112 27.7109C33.4467 27.7109 35.1121 29.3764 35.1121 31.4119C35.1121 33.4474 33.4467 35.1128 31.4112 35.1128ZM56.6449 48.2343H44.5327C43.2374 48.2343 42.1776 49.2941 42.1776 50.5894C42.1776 51.8848 43.2374 52.9446 44.5327 52.9446H56.6449C57.9402 52.9446 59 51.8848 59 50.5894C59 49.2941 57.9402 48.2343 56.6449 48.2343Z" fill="black" />
                            </svg>
                        </div>
                    </Link>
                    <div className="row">
                        <div className="six columns pro-container__checkoutColumn">
                            <div className="pro-container__checkoutAbout">
                                <p className="pro-container__table-feature titleMinSub">Selecciona tu plan</p>
                                <p className="pro-container__table-featureAbout">Con Okki PRO lleva tu tienda Okki al siguiente nivel pagando una sola cuota al año o mes tras mes.</p>
                                <Link className="pro-container__table-featureLink" to="/pro">Beneficios <span>↗</span></Link>
                                <div className="pro-container__checkoutPlans">
                                    <div className={isToggled ? "pro-container__table-freeCheckout" : "pro-container__table-freeCheckout pro-container__table-freeCheckout-checked"} onClick={() => { changePlan(isToggled) }}>

                                        <svg className="pro-container__check" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="white" />
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0483 7.38817C14.3309 7.69098 14.3146 8.16557 14.0117 8.4482L9.51174 12.6482C9.22359 12.9171 8.77642 12.9171 8.48826 12.6482L5.98826 10.3149C5.68545 10.0322 5.66909 9.55765 5.95171 9.25483C6.23434 8.95202 6.70893 8.93565 7.01174 9.21828L9 11.074L12.9883 7.35161C13.2911 7.06899 13.7657 7.08535 14.0483 7.38817Z" fill="white" />
                                        </svg>

                                        <p><span>$250 MXN</span></p>
                                        <p>Mensual</p>
                                    </div>
                                    <div className={isToggled ? "pro-container__table-freeCheckout pro-container__table-freeCheckout-checked" : "pro-container__table-freeCheckout"} onClick={() => { changePlan(isToggled) }}>
                                        <svg className="pro-container__check" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="white" />
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0483 7.38817C14.3309 7.69098 14.3146 8.16557 14.0117 8.4482L9.51174 12.6482C9.22359 12.9171 8.77642 12.9171 8.48826 12.6482L5.98826 10.3149C5.68545 10.0322 5.66909 9.55765 5.95171 9.25483C6.23434 8.95202 6.70893 8.93565 7.01174 9.21828L9 11.074L12.9883 7.35161C13.2911 7.06899 13.7657 7.08535 14.0483 7.38817Z" fill="white" />
                                        </svg>
                                        <p><span>$2,500 MXN</span></p>
                                        <p>Anual</p>
                                    </div>
                                </div>
                                <p className="pro-container__checkoutMessage">
                                    Prueba la funcionalidad <strong>PRO GRATIS durante los primeros 30 días</strong>, el primer cobro se realizará al terminar éste periodo. Recuerda, puedes cancelar tu plan cuando lo desees.
                                </p>
                            </div>
                        </div>
                        <div className="six columns">
                            <div className="pro-container__checkoutForm" id="card-form">
                                <Link to="/pro">
                                    <svg className="pro-container__checkoutClose" width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.5" width="41" height="41" rx="20.5" fill="white" stroke="#EEEEEE" />
                                        <path d="M25.2422 16.7573L16.7569 25.2426" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M25.2431 25.2426L16.7578 16.7573" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </Link>


                                <div className="pro-container__checkoutForm-box">
                                    <div className="registerForm-inputRow">
                                        <label className="pro-container__checkoutForm-label">Nombre en la tarjeta</label>
                                        <input
                                            type="text"
                                            className={nameError ? "input registerInput inputError" : "input registerInput"}
                                            placeholder="Nombre en la tarjeta"
                                            onChange={e => setName(e.target.value)}
                                        />
                                        <div className="fieldError">
                                            {nameError}
                                        </div>
                                    </div>
                                    <div className="registerForm-inputRow" style={{ position: "relative" }}>
                                        <label className="pro-container__checkoutForm-label">Número de la tarjeta</label>
                                        <NumberFormat className={cardError ? "input registerInput inputError" : "input registerInput"} placeholder="4111 1111 1111 1111" displayType={'input'} format="#### #### #### ####" onChange={handleCardChange} />

                                        {/* <input
                                    type="text"
                                    class="input registerInput"
                                    placeholder="0000 0000 0000 0000"
                                    

                                /> */}
                                        <div className={current_card == 'visa' ? "planContainer-form__cardIcons visaActive" : current_card == 'amex' ? "planContainer-form__cardIcons amexActive" : current_card == 'mastercard' ? "planContainer-form__cardIcons mcActive" : "planContainer-form__cardIcons noneActive"}>


                                            <svg className="visaIcon" width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="24" height="16" rx="2" fill="#2A2A6C" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.169 8.80984C15.169 8.07867 14.5655 7.76056 14.0841 7.50678C13.7623 7.33712 13.495 7.19621 13.499 6.97984C13.499 6.80984 13.659 6.62984 13.999 6.58984C14.4031 6.55169 14.8101 6.62067 15.179 6.78984L15.389 5.78984C15.0335 5.65879 14.6578 5.5911 14.279 5.58984C13.089 5.58984 12.279 6.21984 12.279 7.11984C12.279 7.77333 12.8672 8.1131 13.3156 8.37212L13.329 8.37984C13.779 8.63984 13.949 8.74984 13.949 8.94984C13.949 9.14984 13.579 9.39984 13.239 9.39984C12.8092 9.41891 12.3819 9.32587 11.999 9.12984L11.779 10.1298C12.2055 10.2847 12.6552 10.3659 13.109 10.3698C14.369 10.3698 15.189 9.74984 15.189 8.78984L15.169 8.80984ZM11.9309 5.68969L10.9309 10.3197H9.74086L10.7409 5.68969H11.9309ZM16.9296 8.68969L17.5596 6.94969L17.9996 8.67969L16.9296 8.68969ZM19.3702 10.3298H18.2702L18.1002 9.63977H16.5702L16.3202 10.3298H15.0602L16.8602 6.03977C16.9455 5.83343 17.147 5.69909 17.3702 5.69977H18.3702L19.3702 10.3298ZM8.27961 10.3197L10.2196 5.68969H8.99961L7.65961 8.83969L7.14961 6.16969C7.11008 5.89576 6.87637 5.69179 6.59961 5.68969H4.59961V5.82969C4.98645 5.91705 5.36217 6.04788 5.71961 6.21969C5.87514 6.30148 5.98002 6.45505 5.99961 6.62969L6.99961 10.3197H8.27961Z" fill="white" />
                                            </svg>


                                            <svg className="mcIcon" style={{ margin: "0 5px" }} width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="24" height="16" rx="2" fill="#F2F0EC" />
                                                <g opacity="0.01">
                                                    <rect x="2.32031" y="1.59985" width="19.35" height="12.8" fill="white" />
                                                </g>
                                                <rect x="9.44922" y="3.82983" width="5.11" height="8.34" fill="#F26122" />
                                                <path d="M9.99899 8.00004C9.99353 6.37747 10.7302 4.84146 11.999 3.83004C9.8254 2.12491 6.7066 2.37536 4.83296 4.40549C2.95932 6.43562 2.95932 9.56445 4.83296 11.5946C6.7066 13.6247 9.8254 13.8752 11.999 12.17C10.7278 11.1605 9.99056 9.62327 9.99899 8.00004Z" fill="#EA1D25" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.4102 11.0798V11.2898H20.3002V11.2298L20.3602 11.0798H20.4102ZM20.2787 11.1763L20.3002 11.2298V11.1298L20.2787 11.1763ZM20.2402 11.0798L20.2787 11.1763L20.2402 11.2598L20.1802 11.1298V11.0798H20.2402ZM20.07 11.1199V11.2899H20V11.1199H20.07Z" fill="#F69E1E" />
                                                <path d="M20.578 8.00004C20.5728 10.0279 19.4131 11.8758 17.5892 12.7622C15.7653 13.6486 13.5958 13.4189 11.998 12.17C13.2753 11.1631 14.0206 9.62644 14.0206 8.00004C14.0206 6.37364 13.2753 4.83694 11.998 3.83004C13.5938 2.57282 15.7677 2.33833 17.5948 3.22633C19.4219 4.11433 20.5807 5.96857 20.578 8.00004Z" fill="#F69E1E" />
                                            </svg>

                                            <svg className="amexIcon" width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="23.9996" height="15.9997" rx="4" fill="white" />
                                                <path d="M4.43992 8.94993V13.0299H8.56985L8.99985 12.4199L9.41984 13.0299H11.9448V12.1099H12.2248C12.479 12.1121 12.7319 12.075 12.9748 11.9999V13.0299H14.6897V12.2999L15.2697 13.0299H23.0796C23.4006 13.0355 23.7165 12.9487 23.9896 12.7799V14.4998C23.7608 15.3859 22.9598 16.0037 22.0446 15.9998H1.99997C0.895415 15.9998 0 15.1044 0 13.9998V7.69996H1.13998L1.37498 7.08997H1.93497L2.16496 7.69996H11.3348V6.96997L11.9148 7.69996H14.3198V7.32996C14.6724 7.58099 15.097 7.71082 15.5297 7.69996H16.9647L17.1947 7.08997H17.7547L17.9997 7.69996H20.4497V6.90997L20.9496 7.69996H22.6396V3.62002H20.8446V4.45001L20.3097 3.62002H18.7397V4.67001L18.2397 3.62002H15.5697C15.118 3.60694 14.6759 3.75194 14.3198 4.03002V3.62002H5.49991L5.19991 4.50001L4.89992 3.60003H2.89995V4.65001L2.42996 3.60003H0.799986L0 5.49999V2.00005C0 0.895501 0.895415 8.63716e-05 1.99997 8.63716e-05H22.0446C22.9635 -0.00840717 23.7699 0.610328 23.9996 1.50006V8.94993H9.42984L8.99985 9.54992L8.57985 8.94993H4.43992Z" fill="#296DB6" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6594 9.59984H12.2144V9.57984C12.4733 9.55808 12.7291 9.64866 12.9166 9.82854C13.1041 10.0084 13.2053 10.2602 13.1943 10.5198C13.2007 10.7826 13.0957 11.0357 12.9052 11.2167C12.7146 11.3977 12.4564 11.4897 12.1944 11.4698H11.3444V12.3998H10.6594V9.59984ZM7.3548 10.1798V9.57986H5.08984V12.3998H7.3548V11.7998H5.76983V11.2998H7.32481V10.6898H5.76983V10.1898L7.3548 10.1798ZM9.39984 10.9998L10.5298 9.59986H9.69984L8.99985 10.4698L8.30486 9.57986H7.45488L8.59986 10.9998L7.49987 12.3998H8.31986L8.99985 11.4998L9.67984 12.4098H10.5398L9.39984 10.9998ZM12.154 10.8898H11.344V10.1798H12.154C12.3446 10.1798 12.499 10.3343 12.499 10.5248C12.499 10.7153 12.3446 10.8698 12.154 10.8698V10.8898ZM16.0849 10.3949C16.1429 10.8864 15.7914 11.3319 15.2999 11.3899L16.2449 12.3999H15.3899L14.5499 11.3999H14.2399V12.3999H13.5599V9.60991H15.0899C15.5814 9.55192 16.0269 9.90337 16.0849 10.3949ZM15.0303 10.8297H14.2403V10.1797H15.0303C15.1192 10.1682 15.2087 10.1957 15.2759 10.2551C15.343 10.3145 15.381 10.4001 15.3803 10.4897C15.3828 10.5799 15.3452 10.6666 15.2776 10.7264C15.2101 10.7862 15.1195 10.8131 15.0303 10.7997V10.8297ZM18.68 9.60986V10.2099L17.0951 10.1899V10.6898H18.64V11.2998H17.0951V11.7998H18.68V12.3998H16.4051V9.60986H18.68ZM20.5642 10.7098H19.9092C19.808 10.7301 19.7045 10.6874 19.6471 10.6016C19.5896 10.5158 19.5896 10.4038 19.6471 10.318C19.7045 10.2321 19.808 10.1894 19.9092 10.2098H21.1242L21.3942 9.60979H19.9292C19.68 9.58091 19.4304 9.66105 19.2445 9.82966C19.0587 9.99826 18.9547 10.2389 18.9593 10.4898C18.9441 10.7232 19.0338 10.9513 19.204 11.1118C19.3742 11.2723 19.6071 11.3486 19.8392 11.3198H20.4992C20.6005 11.2994 20.704 11.3421 20.7614 11.4279C20.8188 11.5138 20.8188 11.6257 20.7614 11.7116C20.704 11.7974 20.6005 11.8401 20.4992 11.8198H19.0393V12.4197H20.4992C20.7512 12.4403 20.9998 12.351 21.1809 12.1746C21.362 11.9983 21.4581 11.7522 21.4442 11.4998C21.4568 11.2687 21.3655 11.044 21.1952 10.8872C21.0249 10.7305 20.7935 10.6581 20.5642 10.6898V10.7098ZM23.7293 10.2098H22.5143L22.4993 10.1898C22.3981 10.1695 22.2946 10.2122 22.2372 10.298C22.1797 10.3838 22.1797 10.4958 22.2372 10.5816C22.2946 10.6675 22.3981 10.7102 22.4993 10.6898H23.1793C23.5252 10.6543 23.8552 10.8434 23.9993 11.1598V11.8298C23.8616 12.211 23.4826 12.4499 23.0793 12.4098H21.6443V11.8098H23.0893C23.1905 11.8302 23.2941 11.7874 23.3515 11.7016C23.4089 11.6158 23.4089 11.5038 23.3515 11.418C23.2941 11.3322 23.1905 11.2895 23.0893 11.3098H22.4443C22.2122 11.3386 21.9792 11.2624 21.8091 11.1019C21.6389 10.9413 21.5491 10.7133 21.5643 10.4798C21.5598 10.2289 21.6638 9.98831 21.8496 9.81971C22.0355 9.65111 22.2851 9.57096 22.5343 9.59985H23.9993L23.7293 10.2098Z" fill="#296DB6" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7251 5.13969C12.7361 5.59043 12.4028 5.97571 11.9551 6.02968L12.8951 7.06966H12.0451L11.2052 6.06968H10.8952V7.06966H10.2002V4.24971H11.7252C11.9799 4.21629 12.2367 4.29526 12.4286 4.4661C12.6205 4.63693 12.7288 4.88276 12.7251 5.13969ZM2.11496 4.24982H1.22498L0 7.06977H0.739987L0.999983 6.49978H2.31496L2.55496 7.08977H3.32494L2.11496 4.24982ZM1.19033 5.9297L1.46532 5.26971L1.64532 4.82972L1.82532 5.26971L2.09531 5.9297H1.19033ZM5.29948 5.87979L5.84947 4.24982H6.94445V7.06977H6.28446V5.21981V4.78981L6.15446 5.21981L5.49947 7.06977H4.89948L4.2595 5.21981L4.1195 4.78981V5.21981V7.06977H3.45451V4.24982H4.55949L5.11948 5.87979L5.20948 6.18979L5.29948 5.87979ZM9.74988 4.84981V4.24982H7.49992V7.06977H9.74988V6.46978H8.16491V5.96979H9.70988V5.3598H8.16491V4.85981L9.74988 4.84981ZM11.6848 5.46977H10.8948V4.84978H11.6848C11.7733 4.83988 11.8619 4.86794 11.9286 4.92702C11.9953 4.9861 12.0339 5.07067 12.0348 5.15978C12.0372 5.24997 11.9996 5.33662 11.9321 5.39645C11.8646 5.45627 11.774 5.48312 11.6848 5.46977ZM13.0538 7.06977V4.24982H13.7388V7.06977H13.0538ZM15.555 4.85969H16.2899V4.2497H15.5C15.1281 4.2262 14.7645 4.36655 14.5049 4.63385C14.2453 4.90115 14.1156 5.26864 14.15 5.63968V5.67968C14.1082 6.0454 14.2298 6.41095 14.4822 6.67883C14.7347 6.94672 15.0924 7.0897 15.46 7.06965H15.5L15.775 6.46966H15.55C15.3425 6.48033 15.1409 6.39826 14.9999 6.24566C14.8589 6.09306 14.793 5.88569 14.82 5.67968V5.63968C14.7962 5.43527 14.8636 5.23075 15.0042 5.0805C15.1448 4.93026 15.3444 4.84949 15.55 4.85969H15.555ZM17.045 4.24982H17.945L19.15 7.08977H18.38L18.14 6.49978H16.805L16.565 7.06977H15.8351L17.045 4.24982ZM17.0254 5.9297L17.2854 5.26971L17.4654 4.82972L17.6354 5.26971L17.9054 5.9297H17.0254ZM21.3046 5.7498V4.24982H21.9996V7.06977H21.1746L20.1296 5.4798L19.9496 5.16981V5.4998V7.08977H19.2796V4.26982H20.1146L21.1146 5.7698L21.3046 6.08979V5.7498Z" fill="#296DB6" />
                                            </svg>


                                        </div>
                                        <div className="fieldError">
                                            {cardError}
                                        </div>
                                    </div>
                                    <div className="pro-container__checkoutForm-cardInfo">
                                        <div className="registerForm-inputRow">
                                            <label className="pro-container__checkoutForm-label">Mes</label>
                                            <input
                                                type="text"
                                                className={monthError ? "input registerInput inputError" : "input registerInput"}
                                                class="input registerInput"
                                                placeholder="01"
                                                onChange={e => setMonth(e.target.value)}

                                            />
                                            <div className="fieldError">
                                                {monthError}
                                            </div>
                                        </div>
                                        <div className="registerForm-inputRow">
                                            <label className="pro-container__checkoutForm-label">Año</label>
                                            <input
                                                type="text"
                                                className={yearError ? "input registerInput inputError" : "input registerInput"}

                                                placeholder="2020"
                                                onChange={e => setYear(e.target.value)}

                                            />
                                            <div className="fieldError">
                                                {yearError}
                                            </div>
                                        </div>
                                        <div className="registerForm-inputRow">
                                            <label className="pro-container__checkoutForm-label">CVC</label>
                                            <input
                                                type="text"
                                                className={cvcError ? "input registerInput inputError" : "input registerInput"}
                                                placeholder="113"
                                                onChange={e => setCvc(e.target.value)}
                                            />
                                            <div className="fieldError">
                                                {cvcError}
                                            </div>
                                        </div>
                                    </div>
                                    {isToggled?
                                    <div className="registerForm-inputRow">
                                        <label className="pro-container__checkoutForm-label">Código de descuento</label>
                                        <input
                                            type="text"

                                            class="input registerInput"
                                            placeholder="OKKICODE"
                                            onChange={e => searchCupon(e.target.value)}
                                        />
                                    </div>
                                    :
                                    null
                                    }
                                    <div className="safe-quote">
                                        <div className="loginContainer-card__row">
                                            <label class="checkboxContainer">
                                                He leído y acepto las <Link className="textLink" to="/terminos">Condiciones del servicio</Link> y la <Link className="textLink" to="/privacy">Política de privacidad</Link> de Okki.
                                    <input
                                                    type="checkbox"
                                                    name="category"
                                                    value={accepted_terms}
                                                    onChange={e => setAcceptedTerms(!accepted_terms)}
                                                />
                                                <span className="checkmarkSquare checkmarkSquare2"></span>
                                            </label>
                                        </div>

                                    </div>
                                    <div className="fieldError">
                                        {termsError}
                                    </div>
                                    <hr style={{ marginBottom: 20 }} />
                                    {cupon.id?
                                        <div className="safe-quotePrice">
                                            <p>
                                                Descuento:
                                            </p>
                                            <p>
                                                <span>{` $${plan_price * cupon.porcentaje / 100} MXN`}</span>
                                            </p>
                                        </div>
                                        :
                                        null
                                    }
                                    <div className="safe-quotePrice">
                                        <p>
                                            Cargo total:
                                </p>
                                        <p>
                                            <span>{` $${cupon.id ? plan_price - (plan_price * cupon.porcentaje / 100): plan_price} MXN`}</span>
                                        </p>

                                    </div>
                                    <button className="button modalItem-info__button" onClick={ConektaPayment}>
                                        {loading ?
                                            <span style={{ marginLeft: "10px" }} >Procesando...</span>
                                            :
                                            <>
                                                Realizar pago
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M16 10H4V17H16V10Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M14 10V7C14 4.8 12.2 3 10 3C7.8 3 6 4.8 6 7V10" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </>
                                        }

                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                null
            }
        </>
    );
}

export default ProCheckout;
